module.exports = __webpack_public_path__ + "img/icon_2.1fbef98f.png";